import { render, staticRenderFns } from "./synopsis.vue?vue&type=template&id=00ce278e&scoped=true&"
import script from "./synopsis.vue?vue&type=script&lang=js&"
export * from "./synopsis.vue?vue&type=script&lang=js&"
import style0 from "./synopsis.vue?vue&type=style&index=0&id=00ce278e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ce278e",
  null
  
)

export default component.exports